import { render, staticRenderFns } from "./EmailConfiguration.vue?vue&type=template&id=67907761&"
import script from "./EmailConfiguration.vue?vue&type=script&lang=js&"
export * from "./EmailConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports